export default {
      id: "ic-ratio-white-usage",
      viewBox: "0 0 48 48",
      url: "/" + "images/icons.3.109.2.svg#ic-ratio-white-usage",
      toString: function () {
        return this.url;
      }
    }